export default "__VITE_ASSET__us20PwGT__"